'use client';

import { useQuery } from '@tanstack/react-query';
import { IncidentService } from '@/app/services/incident/incident.service';
import type { IncidentDetail } from '@/app/dashboard/mock-data';

export function useIncidentDetail(incidentId: string) {
  const query = useQuery({
    queryKey: ['incidents', 'detail', incidentId],
    queryFn: () => IncidentService.findDetailById(incidentId),
    enabled: Boolean(incidentId.trim()),
  });

  return {
    data: (query.data ?? null) as IncidentDetail | null,
    error: (query.error ?? null) as Error | null,
    isFetching: query.isFetching,
    isLoading: query.isLoading,
    refetch: query.refetch,
  };
}
